package com.milta.core.photodownload

import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement

/**
 * No fetch/blob round-trip: a plain `<a download>` click lets the browser handle the save exactly
 * like a manual "Enregistrer l'image sous" — the same underlying request MIL-52's native
 * right-click save already relied on, so no new CORS exposure is introduced. A cross-origin host
 * without `Content-Disposition: attachment` may open the image in a new tab instead of forcing a
 * download in some browsers — an accepted MVP limitation, not a regression from the prior behavior.
 */
class JsPhotoDownloader : PhotoDownloader {
    override suspend fun saveToGallery(photoUrl: String, fileName: String) {
        val anchor = (document.createElement("a") as HTMLAnchorElement).apply {
            href = photoUrl
            download = fileName
            style.display = "none"
            target = "_blank"
        }
        document.body?.appendChild(anchor)
        anchor.click()
        anchor.parentNode?.removeChild(anchor)
    }
}
